var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"d9edec1b5f39396c63491c3ea65e9cb8203b8ec8"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["availroom-os@availroom"]={id:"d9edec1b5f39396c63491c3ea65e9cb8203b8ec8"};
      